import React from "react";
import styled from "styled-components";
import {darkBoxShadowColour, subduedTextColour} from "../../../../style/styleConsts";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    cursor: pointer;
    align-items: stretch;
    justify-content: center;
    width: 64px;
    color: ${({selected}) => selected ? "#3b7433" : subduedTextColour};
    border-bottom: ${({selected}) => selected ? "solid 5px #3b7433" : "none"};
    
    :hover {
        background-color: ${darkBoxShadowColour};
    }
`;

const OptionText = styled.div`
    display: flex;
    align-items: center;
    padding-top: 2px;
    padding-bottom: ${props => props.paddingBottom};
    font-size: 14px;
`;

export const Option = ({text, className, selected, onClick}) => {
    const paddingBottom = selected ? "0" : "5px";

    return <Container className={className}
                      selected={selected}
                      onClick={onClick}>
        <OptionText paddingBottom={paddingBottom}>
            <div>{text}</div>
        </OptionText>
    </Container>;
};